export default "__VITE_ASSET__BGV2Gbft__"